import React from 'react';
import { FlozyLoader } from './FlozyLoader';
import { cn } from '@/lib/utils';

interface LoadingMoreProps {
  className?: string;
}

export function LoadingMore({ className }: LoadingMoreProps) {
  return (
    <div className={cn("flex items-center justify-center gap-2", className)}>
      <div className="scale-50 origin-center">
        <FlozyLoader size='sm' isLoading={true} />
      </div>
      <span className="text-sm text-muted-foreground">Loading more...</span>
    </div>
  );
}